import React from "react";
import ExcelImportPage from "./ExcelImportPage";

const contentByEndpoint = {
  "/customs/import-headings/": {
    description:
      "فایل سرگروه‌ها را بارگذاری کنید تا رکوردهای Heading ساخته شوند و با استفاده از دو رقم اول کد به فصل‌های موجود متصل شوند.",
    requiredColumns: ["code", "description"],
  },
  "/customs/import-seasons/": {
    description:
      "فایل فصل‌ها را بارگذاری کنید تا رکوردهای Season ساخته شوند. هر ردیف باید شامل کد دو رقمی فصل و شرح آن باشد.",
    requiredColumns: ["code", "description"],
  },
};

const ImportComponent = ({ endpoint, title }) => {
  const config = contentByEndpoint[endpoint] || {
    description: "فایل اکسل مربوط به این مسیر را بارگذاری کنید.",
    requiredColumns: ["code", "description"],
  };

  return (
    <ExcelImportPage
      title={title}
      endpoint={endpoint}
      fileFieldName="file"
      description={config.description}
      requiredColumns={config.requiredColumns}
    />
  );
};

export default ImportComponent;
